module.exports = __webpack_public_path__ + "img/loukaniko.5ee79004.jpg";